module.exports = __webpack_public_path__ + "img/img-6-mobile.7f45f847.png";